import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Middle-truncate a file name so long names stay readable while preserving
 * the extension. E.g. `shortenFileName("very-long-architecture-final-v3.pdf", 24)`
 * returns something like `very-long-arc…v3.pdf`.
 */
export function shortenFileName(name, max = 28) {
  if (!name) return "";
  const s = String(name);
  if (s.length <= max) return s;
  const dot = s.lastIndexOf(".");
  const ext = dot > 0 && dot >= s.length - 6 ? s.slice(dot) : "";
  const base = ext ? s.slice(0, s.length - ext.length) : s;
  const keep = Math.max(6, max - ext.length - 1); // 1 char for ellipsis
  const headLen = Math.ceil(keep * 0.6);
  const tailLen = Math.max(2, keep - headLen);
  return `${base.slice(0, headLen)}…${base.slice(base.length - tailLen)}${ext}`;
}
